import React from 'react'

function Footer() {
    return (
        <div>
            <footer style={{ marginTop: "auto", padding: "20px", background: "#f8f8f8" }}>
                <h5>Smart ERP</h5>
                <p>©2026 Unplanned Holiday. All rights reserved. </p>
                {/* Optional: add social icons or partner logos here */}
            </footer>
        </div>
    )
}

export default Footer